import React from 'react';
import Flexbox from 'flexbox-react';
import { Col, Row } from 'antd';
import Wrapper from '../LandingBlockWrapper/BlockWrapper';
import { FormattedMessage, injectIntl } from 'react-intl';
import messages from './messages';

import icon1 from '../../assets/icons/1.svg';
import icon2 from '../../assets/icons/2.svg';
import icon3 from '../../assets/icons/3.svg';
import icon4 from '../../assets/icons/4.svg';
import icon5 from '../../assets/icons/5.svg';


const list = [
	{
		icon: icon1,
		label: messages.labelIcon1,
	}, {
		icon: icon2,
		label: messages.labelIcon2,
	}, {
		icon: icon3,
		label: messages.labelIcon3,
	}, {
		icon: icon4,
		label: messages.labelIcon4,
	}, {
		icon: icon5,
		label: messages.labelIcon5,
	}];

const Item = injectIntl(({ icon, label, intl: { formatMessage } }) => (
	<Col xs={24} sm={12} md={6} lg={4} className='Item'>
      <span>
        <img alt={'icon'} src={icon}/>
      </span>
		<div>{formatMessage(label)}</div>
	</Col>
));

export default () => (
	<Wrapper className='Platform'>
		<Flexbox flexDirection='column'>
			<Row style={{ width: '100%' }} type='flex' justify='center'>
				<Col span={16}>
					<h2>
						<FormattedMessage {...messages.title} />
					</h2>
				</Col>
			</Row>
			<Row style={{ width: '100%' }} type='flex' justify='center'>
				<Col span={16}>
					<p>
						<FormattedMessage {...messages.description} />
					</p>
				</Col>
			</Row>
			<Row>
				<Col sm={0} md={24} style={{ marginBottom: 60 }}/>
			</Row>
			<Row style={{ width: '100%' }} type='flex' justify='center'
			     gutter={{ md: 26 }}>
				{list.map(i => <Item key={i.icon} {...i}/>)}
			</Row>
		</Flexbox>
	</Wrapper>
);


// WEBPACK FOOTER //
// ./src/components/LandingPlatform/Platform.js